var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSunIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none",
  viewBox: "0 0 20 21",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#27333F",
  d: "M14.375 10.804a4.376 4.376 0 1 1-8.751 0 4.376 4.376 0 0 1 8.751 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.375 3.93V2.053a.625.625 0 0 1 1.25 0V3.93a.625.625 0 1 1-1.25 0M15 10.803a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-1.25 0a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0M4.558 6.246a.625.625 0 0 0 .884-.884l-1.25-1.25a.625.625 0 0 0-.884.884zm0 9.116-1.25 1.25a.626.626 0 0 0 .884.884l1.25-1.25a.624.624 0 1 0-.884-.884M15 6.429a.63.63 0 0 0 .442-.183l1.25-1.25a.625.625 0 0 0-.884-.884l-1.25 1.25A.625.625 0 0 0 15 6.429m.442 8.933a.626.626 0 0 0-.884.884l1.25 1.25a.625.625 0 1 0 .884-.884zM3.75 10.804a.625.625 0 0 0-.625-.625H1.25a.625.625 0 0 0 0 1.25h1.875a.625.625 0 0 0 .625-.625m6.25 6.25a.625.625 0 0 0-.625.625v1.875a.625.625 0 1 0 1.25 0V17.68a.625.625 0 0 0-.625-.625m8.75-6.875h-1.875a.625.625 0 0 0 0 1.25h1.875a.625.625 0 1 0 0-1.25"
})));
export { SvgSunIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/sunIcon.svg";